import React from "react";

import Tooltip from "react-simple-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

function InstitutionTooltip({ name, equallyContributing, institution, index }) {
  const content = (
    <div>
      <sup>{index}</sup> {institution}
      <br />
      {equallyContributing ? "* These authors contributed equally to this work." : ""}
    </div>
  );
  return (
    <Tooltip
      content={content}
      placement="right"
      background="rgba(1.0, 1.0, 1.0, 0.9)"
      className="description-tooltip"
    >
      {name}
      <sup>
        {index}
        {equallyContributing ? ",*" : ""}
      </sup>
    </Tooltip>
  );
}

type Contributor = {
  name: string,
  institution: string,
  equallyContributing?: boolean,
};

type Props = {
  title: string,
  contributors: Contributor[],
};

export default function Header({ title, contributors }: Props) {
  const institutions = Array.from(new Set(contributors.map(({ institution }) => institution)));
  const institutionToIndex = Object.fromEntries(
    institutions.map((institution, index) => [institution, index + 1]),
  );
  return (
    <div className="header">
      <div className="header-title">
        <a
          href="https://scalableminds.com/image-analysis"
          target="_blank"
          rel="noopener noreferrer"
          className="paper-link"
        >
          <span>
            {title}
            <FontAwesomeIcon icon={faLink} size="xs" style={{ marginLeft: 10 }} />
          </span>
          <div className="paper-authors">
            {Object.values(contributors).map(
              ({ name, institution, equallyContributing }, index) => (
                <>
                  {index > 0 ? ", " : ""}
                  <InstitutionTooltip
                    name={name}
                    key={name}
                    institution={institution}
                    equallyContributing={equallyContributing}
                    index={institutionToIndex[institution]}
                  />
                </>
              ),
            )}
            .
          </div>
        </a>
      </div>
      <div className="logos">
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <a
            href="https://brain.mpg.de/home.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ height: 50 }}
          >
            <img
              src="mpi-brain-white.svg"
              alt="Max Planck Institute of Brain Research Logo"
              style={{ height: 50 }}
            />
          </a>
          <a
            href="https://brain.mpg.de/home.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ height: 70 }}
          >
            <img
              src="MPG_Logo_RGB_white.png"
              alt="Max Planck Gesellschaft Logo"
              style={{ height: 70 }}
            />
          </a>
          <a
            href="https://scalableminds.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ height: 60 }}
          >
            <img src="scalableminds_logo.svg" alt="scalable minds Logo" style={{ height: 60 }} />
          </a>
        </div>
      </div>
    </div>
  );
}
